import { RouterMap } from '../../types';

export const routeMap: RouterMap = new Map();

routeMap.set('/abnormal/check', {
  name: 'AbnormalCheck',
  meta: {
    nav: [
      { title: '待处理异常', id: 10 },
      { title: '已处理异常', id: 20 },
    ],
  },
});
